const DEFAULT_WIDTH = 11.63;
function estimateStringWidth(string, characterWidths) {
  let sum = 0;
  for (const char of string) {
    let charWidth = characterWidths[char];
    if (charWidth == null || isNaN(charWidth)) {
      var _characterWidths$W;
      charWidth = (_characterWidths$W = characterWidths.W) !== null && _characterWidths$W !== void 0 ? _characterWidths$W : DEFAULT_WIDTH;
    }
    sum += charWidth;
  }
  return sum;
}

export { estimateStringWidth };
